import type { EquipmentResponse } from "../../components/shared/EquipmentDropdown.types";

export const centralizedEquipmentBySicMock = {
  default: {
    available: [
      {
        equipmentId: 101,
        refNumber: "DYLT242201",
        doorNumber: null,
        status: { id: 20, name: "EMTY" },
        assignedTo: null,
        homeSicId: 111,
        loadSummary: { bills: 0, weight: 0, pallets: 0, pieces: 0 },
        equipmentType: { id: 2, name: "Trailer" },
        lengthFt: 53,
        ownership: { ownershipType: "C", ownershipScacCode: null },
        currentSealNumber: null,
        lastUpdateDate: "2025-12-26T10:00:00",
        daysAging: 2,
      },
      {
        equipmentId: 201,
        refNumber: "TRC-10001",
        doorNumber: null,
        status: { id: 20, name: "EMTY" },
        assignedTo: null,
        homeSicId: 111,
        loadSummary: { bills: 0, weight: 0, pallets: 0, pieces: 0 },
        equipmentType: { id: 1, name: "Tractor" },
        lengthFt: null,
        ownership: { ownershipType: "C", ownershipScacCode: null },
        currentSealNumber: null,
        lastUpdateDate: "2025-12-26T09:00:00",
        daysAging: 0,
      },
      {
        equipmentId: 301,
        refNumber: "ST-5001",
        doorNumber: null,
        status: { id: 20, name: "EMTY" },
        assignedTo: null,
        homeSicId: 111,
        loadSummary: { bills: 0, weight: 0, pallets: 0, pieces: 0 },
        equipmentType: { id: 3, name: "Straight Truck" },
        lengthFt: 26,
        ownership: { ownershipType: "C", ownershipScacCode: null },
        currentSealNumber: null,
        lastUpdateDate: "2025-12-26T08:00:00",
        daysAging: 1,
      },
    ],
    assigned: [
      {
        equipmentId: 102,
        refNumber: "DYLT195042",
        doorNumber: null,
        status: { id: 10, name: "ENRT" },
        assignedTo: {
          id: 3203628,
          type: "Route",
          name: "DALLAS NORTH-1",
          status: "CARV",
          linehaulInfo: null,
        },
        homeSicId: 111,
        loadSummary: { bills: 10, weight: 1200, pallets: 5, pieces: 3 },
        equipmentType: { id: 2, name: "Trailer" },
        lengthFt: 53,
        ownership: { ownershipType: "F", ownershipScacCode: "YYE" },
        currentSealNumber: null,
        lastUpdateDate: "2025-12-26T07:00:00",
        daysAging: 0,
      },
      {
        equipmentId: 103,
        refNumber: "DYLT205016",
        doorNumber: null,
        status: { id: 15, name: "LDDK" },
        assignedTo: {
          id: 102030,
          type: "Trip",
          name: "102030",
          status: "LDDK",
          linehaulInfo: { originSicId: 111, destinationSicId: 222 },
        },
        homeSicId: 111,
        loadSummary: { bills: 8, weight: 900, pallets: 4, pieces: 12 },
        equipmentType: { id: 2, name: "Trailer" },
        lengthFt: 53,
        ownership: { ownershipType: "C", ownershipScacCode: null },
        currentSealNumber: null,
        lastUpdateDate: "2025-12-26T06:00:00",
        daysAging: 0,
      },
    ],
    loadAndHold: [
      {
        equipmentId: 104,
        refNumber: "ABC-123",
        doorNumber: null,
        status: { id: 15, name: "EMTY" },
        assignedTo: {
          id: 869430,
          type: "Trip",
          name: "869430",
          status: "LDDK",
          linehaulInfo: null,
        },
        homeSicId: 111,
        loadSummary: { bills: 10, weight: 1200, pallets: 5, pieces: 3 },
        equipmentType: { id: 2, name: "Trailer" },
        lengthFt: 48,
        ownership: { ownershipType: "F", ownershipScacCode: "ORGN" },
        currentSealNumber: null,
        lastUpdateDate: "2025-12-25T10:30:00",
        daysAging: 1,
      },
    ],
  } satisfies EquipmentResponse,
};
